import React, { Component, useState } from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import { unmountComponentAtNode } from 'react-dom';
import BaseOverlay from '../components/overlay';


const Overlay = ({ children, onCloseCB }) => {
  const [isOpen, setIsOpen] = useState(true);
  const onClose = () => {
    if (onCloseCB) {
      onCloseCB();
    }

    setIsOpen(false);
    history.pushState('', document.title, window.location.pathname);

    setTimeout(() => {
      const els = document.querySelectorAll('[data-overlay]');
      els.forEach((el) => {
        unmountComponentAtNode(el);
      });
    }, 350);
  };
  return (
    <div className={ `modal ${ isOpen ? 'is-open' : '' }` } aria-hidden={ isOpen ? 'false' : 'true' }>
      <BaseOverlay onClose={ onClose }>
        { children }
      </BaseOverlay>
    </div>
  );
};

const Modal = ({ parsedContent, modalClasses, onCloseCB }) => {
  return (
    <Overlay onCloseCB={ onCloseCB }>
      <div className='modal__overlay'>
        <div className={ `modal__container ${ modalClasses || '' }` }>
          { parsedContent }
        </div>
      </div>
    </Overlay>
  );
};


const ShortlistButton = ({ isShortlisted, isLargeBtn, onClick }) => {
  return (
    <button
      className={ `btn ${ isLargeBtn ? 'btn_secondary' : 'btn_tertiary' }` }
      onClick={ onClick }
    >
      {isShortlisted ? (<i className='icon icon_tick u-mr--xsmall' />) : (<i className='icon icon_heart_tertiary u-mr--xsmall' />)}
      {isShortlisted ? ('Shortlisted') : ('Shortlist')}
    </button>
  );
};


const ShortlistCount = ({ itemsCount, url }) => {
  return (
    <a href={ url } className='main-nav__item-link relative'>
      <span>
      Shortlist
        <i className='icon icon_heart' />
        { (itemsCount > 0) && (
          <div className='shortlist-count'> { itemsCount }</div>
        ) }
      </span>
    </a>
  );
};


const VideoButton = ({ buttonContent, buttonClass, buttonIcon, onClick }) => {
  return (
    <button className={ `btn ${ buttonClass }` } onClick={ onClick }>
      <i className={ `icon ${ buttonIcon }` } />
      {' '}
      { buttonContent || 'Video' }
    </button>
  );
};


const VideoOverlay = ({ videoSrc }) => {
  return (
    <Overlay>
      <div className='overlay'>
        <div className='modal__inner-video'>
          <div className='wrapper wrapper--large'>
            <div className='grid grid--col-spacing'>
              <div className='lg-o2 lg-c8'>
                <div className='overlay__video'>
                  <div className='media'>
                    <div className='media__video'>
                      <iframe className='media__video-player' width='100%' height='100%' src={ videoSrc } frameBorder='0' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Overlay>
  );
};

export {
  Modal,
  ShortlistButton,
  ShortlistCount,
  VideoButton,
  VideoOverlay,
};
